import Middleware from './Middleware';
import { EventTypes } from '../events';
export default (function (type) {
  return function (f) {
    return Middleware(function (evt, store) {
      switch (evt.type) {
        case type:
          return f(evt, store);

        default:
          return evt;
      }
    });
  };
});